<template>
  <v-form lazy-validation v-model="valid" ref="form">
    <v-row>
      <v-col cols="12" md="9">
        <v-card class="d-flex flex-column white rounded pa-9 d-flex items-center justify-start"
                :loading="loading">
          <v-row align="center" justify="space-between">
            <v-col cols="12" md="10" class="d-flex align-items-start">
              <v-card-title class="secondary--text font-weight-bold">
                {{$t('campus_group_admins.general_information')}}
              </v-card-title>
            </v-col>
            <v-col cols="12" md="2" class="d-flex align-items-start justify-content-end">
                <v-btn fab small color="deep-purple lighten-1" class="ml-auto" dark
                       :disabled="loading"
                       @click="update()">
                  <v-icon>
                    mdi-content-save
                  </v-icon>
                </v-btn>
            </v-col>
          </v-row>
          <v-col cols="12">
            <v-row align="center" justify="center" class="mb-1">
              <v-col>
                <span>ID: </span>
                <span class="deep-purple--text font-weight-bold">{{campusGroupAdminId}}</span>
              </v-col>
              <v-col>
                <span>{{$t('students.creation_date')}}: </span>
                <span class="deep-purple--text font-weight-bold">
                  {{created |  moment('MM/D/YYYY')}}
                </span>
              </v-col>
              <v-col>
                <span>{{$t('students.last_access')}}: </span>
                <span class="deep-purple--text font-weight-bold d-block">
                  {{lastAccessDate || $t('students.without_last_access')}}
                </span>
              </v-col>
            </v-row>
            <v-divider/>
          </v-col>

          <!-- Editable data -->
          <!-- Personal information -->
          <v-row align="center" justify="center">
            <v-col cols="12" md="5">

              <v-row align="start" justify="start" class="d-flex flex-column">
                <span class="body black--text my-1">{{$t('campus_group_admins.dni')}}</span>
                <v-text-field
                  filled
                  flat
                  dense
                  :placeholder="$t('campus_group_admins.dni')"
                  :rules="dniRule"
                  v-model="adminToSave.dni"
                />
              </v-row>
              <v-row align="start" justify="start" class="d-flex flex-column">
                <span class="body black--text my-1">{{$t('campus_group_admins.firstname')}}</span>
                <v-text-field
                  filled
                  flat
                  dense
                  :placeholder="$t('campus_group_admins.firstname')"
                  :rules="requiredRule('firstname')"
                  v-model="adminToSave.firstname"
                />
              </v-row>
              <v-row align="start" justify="start" class="d-flex flex-column">
                <span
                  class="body black--text my-1">{{$t('campus_group_admins.lastname')}}</span>
                <v-text-field
                  dense
                  :placeholder="$t('campus_group_admins.lastname')"
                  filled
                  flat
                  v-model="adminToSave.lastname"
                  :rules="requiredRule('lastname')"
                />
              </v-row>
              <v-row align="start" justify="start" class="d-flex flex-column">
                <span
                  class="body black--text my-1">{{$t('campus_group_admins.lastname2nd')}}</span>
                <v-text-field
                  dense
                  :placeholder="$t('campus_group_admins.lastname2nd')"
                  filled
                  flat
                  v-model="adminToSave.lastname2nd"
                />
              </v-row>

              <v-row align="start" justify="start" class="d-flex flex-column">
                <span
                  class="body black--text my-1">{{$t('campus_group_admins.email')}}</span>
                <v-text-field
                  dense
                  :placeholder="$t('campus_group_admins.email')"
                  filled
                  flat
                  v-model="adminToSave.email"
                  :rules="emailRule"
                />
              </v-row>

            </v-col>
            <v-divider vertical class="mx-1"/>

            <!-- Grupo de Sede information -->
            <v-col cols="12" md="6" style="margin-top:-200px">
              <v-row align="center" justify="center" class="d-flex flex-column">
                <span class="black--text">{{$t('students.state')}}</span>
                <v-radio-group v-model="adminToSave.active" row>
                  <v-radio
                    :label="$t('students.active')"
                    :value="true"
                    color="deep-purple lighten-1"
                  />
                  <v-radio
                    :label="$t('students.inactive')"
                    :value="false"
                    color="deep-purple lighten-1"
                  />
                </v-radio-group>
              </v-row>
              <v-divider/>

              <v-col cols="12" class="pa-3">
                <v-row align="start" justify="center" class="d-flex flex-column">
                  <span class="body black--text my-1">
                    {{$t('campus_group_admins.campus_group')}}
                  </span>
                  <v-autocomplete
                    class="w-100"
                    filled
                    flat
                    dense
                    v-model="adminToSave.campus_group_id"
                    :items="campusGroups"
                    item-value="id"
                    item-text="name"
                    :placeholder="$t('campus_group_admins.select_campus_group')"
                    :rules="requiredRule('campus_group')"
                  />
                </v-row>
              </v-col>
            </v-col>

          </v-row>

        </v-card>
      </v-col>

      <v-col cols="12" md="3" class="h-100">
        <v-row align="center" justify="center" class="h-100">
          <v-col cols="12" class="pb-0">
            <v-alert rounded outlined light color="deep-purple" class="pa-2 mb-0">
              <h4 class="text-left deep-purple--text lighten-2 font-weight-semibold">
                Acciones:
              </h4>
             <v-btn
                rounded
                small
                color="deep-purple lighten-1"
                dark
                @click.prevent="openChangePassword()"
              >
                {{$t('students.create_new_information')}}
              </v-btn>
            </v-alert>
            </v-col>
        </v-row>
      </v-col>

      <!-- MODALS FOR THE PAGE -->
      <general-modal-container @onClose="closeChangePassword()" v-if="isChangePasswordModalOpen">
        <student-change-password-modal
          :student-name="adminInfo.name"
          :student-username="adminInfo.username"
          :student-id="adminInfo.id"
          :country-id="adminInfo.country_id"
          v-model="newPassword"
          :disabled-buttons="modalLoading"
          @onSave="onSavePassword()"
          @onCancel="closeChangePassword()"
        />
      </general-modal-container>
    </v-row>
  </v-form>
</template>

<script>
// Modals
import GeneralModalContainer from '@/components/core/modals/GeneralModalContainer.vue';
import StudentChangePasswordModal from '@/components/students/StudentChangePasswordModal.vue';

import LoadingMixin from '../../mixins/loading';
import SnackbarMixin from '../../mixins/snackbar';
import campusGroupAdminService from '../../services/campusGroupAdmin.service';
import userService from '../../services/user.service';

export default {
  name: 'CampusGroupAdminEdit',
  props: { campusGroupAdminId: { type: [Number, String], default: 0 } },
  components: {
    GeneralModalContainer,
    StudentChangePasswordModal,
  },
  data: () => ({
    valid: false,
    loading: false,
    modalLoading: false,
    menu: false,
    activePicker: null,
    isChangePasswordModalOpen: false,
    newPassword: '',
    created: null,
    lastAccessDate: null,
    campusGroups: [],
    adminInfo: {},
    adminToSave: {
      dni: '',
      firstname: '',
      lastname: '',
      lastname2nd: '',
      email: '',
      birth_date: null,
      country_id: 1,
      active: true,
      campus_group_id: null,
    },
  }),
  mixins: [LoadingMixin, SnackbarMixin],
  async mounted() {
    await this.loadCampusGroupAdmin();
    await this.loadCampusGroups();
  },
  methods: {
    async loadCampusGroupAdmin() {
      this.loader();
      try {
        const adminId = parseInt(this.campusGroupAdminId, 10);
        const response = await campusGroupAdminService.getCampusGroupAdmin(adminId);
        const admin = response.data.data || response.data;

        this.adminInfo = {
          id: admin.id,
          name: `${admin.firstname} ${admin.lastname}`,
          username: admin.username,
        };

        this.adminToSave = {
          dni: admin.dni || '',
          firstname: admin.firstname || '',
          lastname: admin.lastname || '',
          lastname2nd: admin.lastname2nd || '',
          email: admin.email || '',
          active: admin.active,
          campus_group_id: admin.campus_group_id ? parseInt(admin.campus_group_id, 10) : null,
        };

        this.created = admin.creationDate;
        this.lastAccessDate = admin.lastAccessDate;
      } catch (error) {
        this.snackbarError('Error al cargar administrador de grupo de sede');
      } finally {
        this.loader();
      }
    },

    async loadCampusGroups() {
      try {
        const response = await campusGroupAdminService.getAvailableCampusGroups();
        const campusGroupsData = response.data.data || response.data || [];

        // Transform the data to match autocomplete format
        this.campusGroups = campusGroupsData.map((group) => ({
          id: parseInt(group.id, 10),
          name: group.name,
          school_group_id: group.school_group_id ? parseInt(group.school_group_id, 10) : null,
        }));
      } catch (error) {
        this.campusGroups = [];
      }
    },

    async update() {
      if (this.$refs.form.validate()) {
        this.loader();
        try {
          const adminId = parseInt(this.campusGroupAdminId, 10);
          await campusGroupAdminService.updateCampusGroupAdmin(
            adminId,
            this.adminToSave,
          );
          this.snackbarSuccess('Administrador de grupo de sede actualizado exitosamente');
        } catch (error) {
          this.snackbarError('Error al actualizar administrador de grupo de sede');
        } finally {
          this.loader();
        }
      }
    },

    openChangePassword() {
      this.isChangePasswordModalOpen = true;
    },

    closeChangePassword() {
      this.isChangePasswordModalOpen = false;
      this.newPassword = '';
    },

    async onSavePassword() {
      this.modalLoading = true;
      try {
        if (this.adminToSave && this.adminToSave.dni) {
          const { dni } = this.adminToSave;
          const response = await userService.changePassword({
            dni,
            country: this.adminInfo.country_id,
            password: this.newPassword,
          });

          if (response.status !== 200) {
            this.snackbarError('Error al cambiar contraseña');
          } else {
            this.snackbarSuccess('Contraseña actualizada exitosamente');
            this.closeChangePassword();
          }
        } else {
          this.snackbarError('No se pudo identificar al administrador');
        }
      } catch (error) {
        this.snackbarError('Error al cambiar contraseña');
      } finally {
        this.modalLoading = false;
      }
    },

    async loadCampusGroupsBySchoolGroup(schoolGroupId) {
      try {
        const response = await campusGroupAdminService.getCampusGroupsBySchoolGroup(schoolGroupId);
        const campusGroupsData = response.data.data || response.data || [];

        // Transform the data to match autocomplete format
        this.campusGroups = campusGroupsData.map((group) => ({
          id: parseInt(group.id, 10),
          name: group.name,
          school_group_id: group.school_group_id ? parseInt(group.school_group_id, 10) : null,
        }));
      } catch (error) {
        this.campusGroups = [];
      }
    },

    requiredRule(field) {
      return [(v) => !!v || `${field} es requerido`];
    },
  },
  computed: {
    dniRule() {
      return [
        (v) => !!v || 'DNI es requerido',
        (v) => v.length >= 8 || 'DNI debe tener al menos 8 caracteres',
      ];
    },

    emailRule() {
      return [
        (v) => !!v || 'Email es requerido',
        (v) => /.+@.+\..+/.test(v) || 'Email debe ser válido',
      ];
    },
  },
  watch: {
    'adminToSave.school_group_id': {
      handler(newSchoolGroupId) {
        if (newSchoolGroupId) {
          this.loadCampusGroupsBySchoolGroup(newSchoolGroupId);
        }
      },
    },
  },
};
</script>

<style scoped>
.w-100 {
  width: 100%;
}
</style>
